module.exports = __webpack_public_path__ + "static/media/Husky909_4c.25a6814c.svg";